import React from 'react'

interface TypographyProps {
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
  children: React.ReactNode
  className?: string
}

export const Typography: React.FC<TypographyProps> = ({ variant, children, className = '' }) => {
  const variantStyles = {
    h1: 'text-4xl font-bold md:text-5xl lg:text-[60px]',
    h2: 'text-3xl font-bold md:text-4xl',
    h3: 'text-2xl font-bold md:text-3xl',
    h4: 'text-xl font-bold md:text-2xl',
    h5: 'text-lg font-bold md:text-xl',
    h6: 'text-base font-bold md:text-lg',
    p: 'text-base'
  }

  const Component = variant

  return (
    <Component className={`${variantStyles[variant]} ${className}`}>
      {children}
    </Component>
  )
}
